import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/moon': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M279.1 512c-141.4 0-256-114.6-256-256 0-141.4 114.6-256 256-256 13 0 33.9 1.9 46.7 4.3 44 8.1 53.8 66.9 15 88.9-41.4 23.5-67.4 67.4-67.4 115.8 0 83.5 75.9 146.5 158.3 130.8 43.7-8.3 74.5 42.6 46.2 77.4-47.9 59-120.1 94.8-198.8 94.8zM279.1 48c-114.9 0-208 93.1-208 208s93.1 208 208 208c65.2 0 123.4-30 161.6-77-111.6 21.3-215.3-64.1-215.3-177.9 0-67.5 36.9-126.4 91.7-157.6-12.3-2.3-25-3.5-38-3.5z'
      }
    ]
  }
})
